import { useEffect, useState } from "react";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  FormGroup,
  Input,
  Row,
  Col,
  Button,
} from "reactstrap";
import { CalenderIcon, DownloadIcon } from "../../Icon";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { NewDownloadIcon, NewDownloadIconActive } from "../../../assets/images";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { handleDate } from "../../../utils/commonFunctions";
import { RadioContainer } from "../../commons";
import { RadioTypes } from "../../../commonTypes/universalTypes";
const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "comment",
    name: "Comment Wise Reports",
  },
  {
    id: "stage",
    name: "Stage Wise Reports",
  },
];

type AppProps = {
  handleDownload: () => void;
  startDate: any;
  endDate: any;
  setStartDate: React.Dispatch<React.SetStateAction<any>>;
  setEndDate: React.Dispatch<React.SetStateAction<any>>;
  type?: string;
  downloadType?: string;
  setDownloadType?: React.Dispatch<React.SetStateAction<string>>;
};

const DownloadCheckInReports = ({
  handleDownload,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  type,
  downloadType,
  setDownloadType,
}: AppProps) => {
  const [showDropdown, setShowDropdown] = useState<boolean>(false);

  useEffect(() => {
    setDownloadType?.("comment");
  }, []);

  const toggleShowDropdown = () => {
    setShowDropdown(!showDropdown);
    setDownloadType?.("comment");
  };

  const handleCancel = () => {
    setStartDate(null);
    setEndDate(null);
    setShowDropdown(!showDropdown);
    setDownloadType?.("comment");
  };

  const handleStartDate = (date: any) => {
    const value = handleDate(date);
    setStartDate(value);
    setEndDate(null);
  };

  const handleEndDate = (date: any) => {
    const value = handleDate(date);
    setEndDate(value);
  };

  const handleRadioValue = (radioValue: string) => {
    setDownloadType?.(radioValue);
  };

  return (
    <>
      <ButtonDropdown
        isOpen={showDropdown}
        toggle={toggleShowDropdown}
        className="download-report-btn"
        style={
          showDropdown
            ? {
                color: "#dd4433",
                backgroundColor: "#fff6f5",
              }
            : {}
        }
      >
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 250 }}
          overlay={
            <Tooltip id="button-view-download-invoice">
              Download Reports
            </Tooltip>
          }
        >
          <DropdownToggle
            caret
            // color="secondary"
            outline
            style={
              showDropdown
                ? {
                    color: "#dd4433",
                    backgroundColor: "#fff6f5",
                  }
                : { border: "1px solid#bfcbe1" }
            }
          >
            <img
              src={showDropdown ? NewDownloadIconActive : NewDownloadIcon}
              alt="download icon"
            />
          </DropdownToggle>
        </OverlayTrigger>
        <DropdownMenu right>
          <div
            className="download-dropdown p-3"
            style={{
              minWidth: type?.length ? "395px" : "",
              fontSize: type?.length ? "14px" : "",
            }}
          >
            <h4>Download Report</h4>
            <hr />
            {type?.length && downloadType && (
              <div className="mt-3 mb-3">
                <label htmlFor="work">Download</label>
                <div className="d-flex align-items-center">
                  <RadioContainer
                    optionsList={RADIO_OPTIONS}
                    handleSetRadioValue={handleRadioValue}
                    radioValue={downloadType}
                    alignment="horizontal"
                  />
                </div>
              </div>
            )}
            <Row>
              <Col md={6} className="form-group">
                <div>Start Date </div>
                <Row>
                  <Col md="12" className="download-report-picker">
                    <Label className="m-0 p-0">
                      <span className="calender-icon">
                        <CalenderIcon />
                      </span>
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        selected={startDate}
                        onChange={handleStartDate}
                        selectsStart
                        showMonthDropdown
                        showYearDropdown
                        startDate={startDate}
                        endDate={endDate}
                        className="form-control"
                      />
                    </Label>
                  </Col>
                </Row>
              </Col>
              <Col md={6} className="form-group">
                <div>End Date</div>
                <Row>
                  <Col md="12" className="download-report-picker">
                    <Label className="m-0 p-0">
                      <span className="calender-icon">
                        <CalenderIcon />
                      </span>
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        selected={endDate}
                        onChange={handleEndDate}
                        selectsEnd
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        className="form-control"
                      />
                    </Label>
                  </Col>
                </Row>
              </Col>
              <Col md={12} className="text-right">
                <button
                  className="btn btn-outline-secondary mr-3"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setStartDate(null);
                    setEndDate(null);
                    setShowDropdown(false);
                    handleDownload();
                  }}
                  disabled={!startDate || !endDate}
                >
                  Download
                </button>
              </Col>
            </Row>
          </div>
        </DropdownMenu>
      </ButtonDropdown>
      {/* {isLoading && <Loader />} */}
    </>
  );
};

export default DownloadCheckInReports;
